<template>
  <div class="login-container">
    <!-- 左侧的盒子 -->
    <div class="left">
      <!-- 标题盒子 -->
      <div class="title-box">
        <!-- <div class="title">租售平台</div>
        <div class="line"></div>
        <div class="sub-title">用户登录</div> -->
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item :index="'1'">租售平台</el-menu-item>
          <el-menu-item :index="'2'">物业服务推荐</el-menu-item>
          <el-menu-item :index="'3'">酒店宴会推荐</el-menu-item>
        </el-menu>
      </div>
      <!-- 表单 -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="43px"
        class="demo-ruleForm login-form"
      >
        <!-- 手机号 -->
        <el-form-item prop="mobile">
          <el-input
            class="high-input"
            prefix-icon="el-icon-user"
            v-model="ruleForm.mobile"
            placeholder="请输入账号"
          ></el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input
            show-password
            prefix-icon="el-icon-lock"
            v-model="ruleForm.password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button class="login-btn" type="primary" @click="login"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 右边的图片 -->
    <img class="bg" src="@/assets/login_banner_ele.png" alt="" />
  </div>
</template>

<script>
import { loginApi } from '@/api/user.js';
import { saveToken } from '@/utils/token.js';
import { getRolePermitAccountApi } from '@/api/user';
import { encrypt } from '@/utils/encryp';
export default {
  name: 'login',

  data() {
    return {
      ruleForm: {
        mobile: '',
        password: '',
      },
      rules: {
        mobile: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
        ],
      },
      activeIndex: '1',
      // 左侧间隙
      formLabelWidth: '60px',
    };
  },
  methods: {
    // 登录类型
    handleSelect(val) {
      console.log('登录类型', val);
      this.activeIndex = val;
    },
    // 登录点击事件
    login() {
      try {
        this.$refs.ruleForm.validate(async (valid) => {
          if (!valid) return;
          await loginApi({
            mobile: encrypt(this.ruleForm.mobile),
            password: encrypt(this.ruleForm.password),
            loginType: Number(this.activeIndex),
          }).then((res) => {
            if (res.code === 200) {
              let {
                token,
                userId,
                roleName,
                nickName,
                headImg,
                areaId,
                houseId,
                roleType,
              } = res.data;
              saveToken(JSON.stringify(token));
              saveToken(
                JSON.stringify({
                  userId,
                  roleName,
                  nickName,
                  headImg,
                  areaId,
                  roleType,
                }),
                'userInfo'
              );
              window.localStorage.setItem('loginType', this.activeIndex);
              if (this.activeIndex == '1') {
                this.$router.replace('/choose');
              } else {
                try {
                  getRolePermitAccountApi({
                    houseId,
                  }).then((res) => {
                    if (res.code === 200) {
                      if (res.data.length === 0) {
                        return this.$message.warning('暂无菜单权限');
                      }
                      let name = res.data[0].menu.url;
                      this.$router.replace({
                        name,
                      });
                    }
                  });
                } catch (error) {
                  console.log(error);
                }
              }
            }
          });
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  display: flex;
  align-items: center;
  background: linear-gradient(
    225deg,
    rgba(1, 198, 250, 1),
    rgba(20, 147, 250, 1)
  );
  justify-content: space-around;
  height: 100%;
  .left {
    width: 478px;
    height: 550px;
    background-color: #f5f5f5;
    padding-top: 44px;
    box-sizing: border-box;

    // 登录表单
    .login-form {
      padding-right: 41px;
      margin-top: 27px;

      // 更高的文本框
      .high-input > input {
        height: 45px;
        line-height: 45px;
      }
    }
    // 表单内部的 按钮
    .login-btn {
      width: 100%;
      margin-left: 0;
    }
    .reset-btn {
      margin-top: 28px;
    }
  }

  .title-box {
    display: flex;
    // 上下居中
    align-items: center;
    margin-left: 48px;
    img {
      margin-right: 16px;
      width: 22px;
      height: 17px;
    }
    .title {
      font-size: 24px;
      font-weight: 400;
      margin-right: 14px;
    }
    .line {
      width: 1px;
      background-color: #dfdfdf;
      margin-right: 12px;
      height: 28px;
    }
    .sub-title {
      font-size: 22px;
      font-weight: 400;
    }
  }
}
</style>

<style lang="less">
.el-menu {
  background-color: #f5f5f5;
}
</style>
